import Hero07 from "./Hero07";
import Contact07 from "./Contact07";

import SeoHead from "../../../seo/SeoHead";
import {
  CONTACT_PAGE_DESCRIPTION,
  CONTACT_PAGE_TITLE,
} from "../../../seo/siteConfig";

function main() {
  return (
    <div>
      <SeoHead
        title={CONTACT_PAGE_TITLE}
        description={CONTACT_PAGE_DESCRIPTION}
        path="/contact"
      />
      <Hero07 />
      <Contact07 />
    </div>
  );
}

export default main;
